// extracted by mini-css-extract-plugin
export var actions = "_76-8";
export var arrow = "_76-5";
export var card = "_76-0";
export var cardWrapper = "_76-9";
export var fieldName = "_76-3";
export var newValue = "_76-6";
export var oldValue = "_76-4";
export var orangeGlowFade = "_76-c";
export var productSection = "_76-1";
export var scrollToBottom = "_76-b";
export var scrollToBottomAnchor = "_76-a";
export var scrollToBottomIcon = "_76-d";
export var showAllButton = "_76-7";
export var table = "_76-2";